// Querys and Mutations
import {
    STATE_ACTIVE
} from '@/graphql/config/StateGraphql'

// models
import { StateModel } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class StateService {
    async getStateActive (): Promise<StateModel[]> {
        const result = await apolloClient.query({
            query: STATE_ACTIVE
        })
        return result.data.statesActive
    }
}

export default new StateService()
